import React, { lazy } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router';
import { CategoryDetailsPage } from '@bonanza-social/games/pages';
import AppLayout from './components/AppLayout/AppLayout';
import { RewardsPage } from '@bonanza-social/rewards/pages';
// import { ShopPage } from '@bonanza-social/shop/pages';
import {
  PrizeWallPage,
  PrizeWallInfoPage,
  PrizeWallWinnersPage,
} from '@bonanza-social/prize-wall/pages';
import {
  LoginPage,
  JoinPage,
  SocialRegistrationPage,
  LogoutPage,
} from '@bonanza-social/registration/pages';

import './navigation';
import { InteracRedirectPage } from '@bonanza-social/wallet/pages';
import ProtectedRoutes from './components/ProtectedRoutes';
import {
  // renderAccountRoutes,
  // renderAuthPromosRoutes,
  renderGamesRoutes,
  renderMiscRoutes,
  // renderPromosRoutes,
  // renderQuestsRoutes,
} from './routes';
import DynamicRoute from './routes/DynamicRoute';
// import { InviteFriendsPage } from '@bonanza-social/invite-friends';

const HomePage = lazy(() => import('./pages/HomePage/HomePage'));
const LandingPage = lazy(() => import('./pages/LandingPage/LandingPage'));
const CommunityJackpotRulesPage = lazy(
  () =>
    import('@bonanza-social/community-jackpot/pages/CommunityJackpotRulesPage'),
);
const CommunityJackpotRoutePage = lazy(
  () =>
    import('@bonanza-social/community-jackpot/pages/CommunityJackpotRoutePage'),
);
const ForgotPasswordNewPasswordPage = lazy(
  () => import('@bonanza-social/auth/pages/ForgotPasswordNewPasswordPage'),
);

const routes = createRoutesFromElements(
  <Route path="/" element={<AppLayout />}>
    {renderMiscRoutes()}
    {renderGamesRoutes()}
    {/* {renderAccountRoutes()} */}
    {/* {renderPromosRoutes()} */}
    {/* {renderAuthPromosRoutes()} */}
    {/* {renderQuestsRoutes()} */}
    <Route
      index
      element={
        <DynamicRoute
          AuthenticatedComponent={HomePage}
          AnonymousComponent={LandingPage}
        />
      }
    />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/logout" element={<LogoutPage />} />
    <Route path="/register" element={<SocialRegistrationPage />} />
    <Route path="/join/:referralCode" element={<JoinPage />} />

    <Route
      path="/resetpassword/reset"
      element={<ForgotPasswordNewPasswordPage />}
    />
    <Route element={<ProtectedRoutes />}>
      <Route path="/interac-redirect" element={<InteracRedirectPage />} />
      <Route path="/rewards" element={<RewardsPage />} />
      {/* <Route path="/shop" element={<ShopPage />} /> */}
      <Route path="/prize-wall/info" element={<PrizeWallInfoPage />} />
      <Route path="/prize-wall/winners" element={<PrizeWallWinnersPage />} />
      <Route path="/prize-wall" element={<PrizeWallPage />} />
      <Route
        path="/communityjackpotrules"
        Component={CommunityJackpotRulesPage}
      />
      <Route path="/communityJackpot" element={<CommunityJackpotRoutePage />} />
      {/* <Route path="/refer-a-friend" element={<InviteFriendsPage />} /> */}
    </Route>
    <Route path=":categorySlug" element={<CategoryDetailsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Route>,
);

export default createBrowserRouter(routes);
